<ng-container *ngIf="permissionData$ | async as permissionData">
  <!-- <mat-card [ngClass]="{'disabled-card': !enabled|| permissionData.ability.cannot('create','document', purchaseTypeMap[permissionData.purchaseTypeId!])}" 
  class="option-box container" *ngIf="!enabledPurchaseTypes.includes(option.title.trim().toLowerCase())">
    <div class="disabled-card-title paragraph-large-medium">
      {{ option.title }}
    </div>
    <div class="disabled-card-content paragraph-large-regular">
      {{ option.description }}
    </div>
  </mat-card>
  <mat-card [ngClass]="{'disabled-card': !enabled || permissionData.ability.cannot('create','document', purchaseTypeMap[option.purchaseTypeId!])}" 
  class="option-box container" *ngIf="enabledPurchaseTypes.includes(option.title.trim().toLowerCase())" (mouseover)="hover=true" (mouseleave)="hover=false" 
  (click)="onClickRedirect()" [ngStyle]="hover ? { 'background-color': '#E5EFFF' } : { 'background-color': '#F0F5FF'}">
    <div class="card-title paragraph-large-medium">
      {{ option.title }}
    </div>
    <div class="card-content paragraph-large-regular">
      {{ option.description }}
    </div>
  </mat-card> -->

  <mat-card 
    [ngClass]="{'disabled-card': option.disabled || permissionData.ability.cannot('create','document', purchaseTypeMap[option.purchaseTypeId!])}" 
    class="option-box container" 
    (click)="!(option.disabled || permissionData.ability.cannot('create','document', purchaseTypeMap[option.purchaseTypeId!])) && onClickRedirect()"
    >
    <div class="card-title paragraph-large-medium">
      {{ option.title }}
    </div>
    <div class="card-content paragraph-large-regular">
      {{ option.description }}
    </div>
  </mat-card>

</ng-container>

